var USER_SERVICE_URL = 'https://cis.mpianalytics.com';
var USER_SERVICE_PATH = '/api/v1/identify';

export default {
  cisBaseUrl: USER_SERVICE_URL,
  cisBasePath: USER_SERVICE_PATH
};